import { Highlight } from 'react-instantsearch-hooks-web'

export const shouldhighlight = (hit, value, attributeName, className) => {
  return hit ? (
    <Highlight attribute={attributeName} className={className} hit={hit} />
  ) : (
    value
  )
}
